
import { Player } from "@/types";

export type DemoPlayer = Player;

export const demoPlayers: DemoPlayer[] = [
  { id: "p1", name: "Alex Johnson", position: "Forward", team_id: "demo" },
  { id: "p2", name: "Sam Williams", position: "Midfielder", team_id: "demo" },
  { id: "p3", name: "Jordan Lee", position: "Defender", team_id: "demo" },
  { id: "p4", name: "Taylor Chen", position: "Forward", team_id: "demo" },
  { id: "p5", name: "Morgan Smith", position: "Midfielder", team_id: "demo" },
];
